import * as yup from 'yup'

export const createNotificationValidation =  yup.object().shape({
    databahanb3Id: yup.string().required('harus diisi'),
    tanggalDiterima: yup.string().required('harus diisi'),
    referenceNumber: yup.string().required('Harus diisi'),
    companyId: yup.string().required('Harus diisi'),
    negaraAsal: yup.string().required('Harus diisi'),
}).required()